function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M10.2974 1H5.70264C3.11233 1 1 3.11233 1 5.70264V10.2974C1 12.8877 3.11233 15 5.70264 15H6.61233V14.0903V9.69604V8.98634C6.61233 8.87589 6.52279 8.78634 6.41233 8.78634H5.70264H4.9163L8 5.10132L11.0837 8.78634H10.2974H9.58766C9.47721 8.78634 9.38766 8.87589 9.38766 8.98634V9.69604V14.1057V14.8154C9.38766 14.9259 9.47721 15.0154 9.58766 15.0154H10.2974C12.8877 15.0154 15 12.9031 15 10.3128V5.70264C15 3.11233 12.8877 1 10.2974 1ZM14.0903 10.3984C14.0903 12.4954 12.4097 14.1057 10.2974 14.1057V9.69604H12.5833C12.753 9.69604 12.8456 9.49802 12.7368 9.3678L8.15325 3.88166C8.07338 3.78606 7.92649 3.78595 7.84648 3.88143L3.24883 9.36757C3.13975 9.49774 3.2323 9.69604 3.40212 9.69604H5.68722V14.1057C3.59031 14.1057 1.87885 12.4097 1.87885 10.2974V5.70264C1.87885 3.60573 3.57489 1.89427 5.68722 1.89427H10.2819C12.3789 1.89427 14.0903 3.59031 14.0903 5.70264V10.2974V10.3984Z",
  fill: "currentcolor",
  stroke: "currentcolor",
  strokeWidth: 0.2
});

const SvgUpdateIcon = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUpdateIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/update-icon.c5c5d6d3.svg";
export { ForwardRef as ReactComponent };